import { OfferModuleWrapper } from 'partial/OfferModuleWrapper/OfferModuleWrapperController';
import React from 'react';
import HomeLoanOffersView from '../components/HomeLoanOffers';

const NewHomeMarketplaceModuleView = props => {
  const {
    mortgageOffers,
    eventHandler,
    activeTab,
    newLoanAmount,
    setNewLoanAmount,
    isNewLoanAmountOpen,
    setNewLoanAmountOpen,
    newLoanType,
    setNewLoanType,
    isNewLoanTypeOpen,
    setNewLoanTypeOpen,
    seenPixel,
    isOfferError,
  } = props;

  return (
    <>
      {seenPixel}
      <OfferModuleWrapper isOfferError={isOfferError}>
        <HomeLoanOffersView
          mortgageOffers={mortgageOffers}
          eventHandler={eventHandler}
          activeTab={activeTab}
          {...props}
          loanAmount={newLoanAmount}
          setLoanAmount={setNewLoanAmount}
          isLoanAmountOpen={isNewLoanAmountOpen}
          setLoanAmountOpen={setNewLoanAmountOpen}
          loanType={newLoanType}
          setLoanType={setNewLoanType}
          isLoanTypeOpen={isNewLoanTypeOpen}
          setLoanTypeOpen={setNewLoanTypeOpen}
        />
      </OfferModuleWrapper>
    </>
  );
};

export default NewHomeMarketplaceModuleView;
